module.exports = __webpack_public_path__ + "img/dental6_7-8-2021.d58d994c.jpg";